import React from "react"
import exclamation from "../../images/exclamation.svg"
import "./index.scss"

export default function ResourceCalendarDoubleBooked() {
  return (
    <img className="exclamation-image" src={exclamation} alt="double booked" />
  )
}
